import { useEffect, useState } from "react";
import { supabase, isSupabaseConfigured } from "../lib/supabaseClient";
import { getDefaultSectionJson } from "../cms/defaults";

/**
 * Loads cms_site_content.data for sectionKey.
 * Falls back to built-in defaults when Supabase is off or row missing.
 */
export function useCmsSection(sectionKey) {
  const [data, setData] = useState(() => getDefaultSectionJson(sectionKey));
  const [loading, setLoading] = useState(isSupabaseConfigured);

  useEffect(() => {
    if (!isSupabaseConfigured || !supabase) {
      setData(getDefaultSectionJson(sectionKey));
      setLoading(false);
      return;
    }

    let cancelled = false;
    (async () => {
      setLoading(true);
      const { data: row, error } = await supabase
        .from("cms_site_content")
        .select("data")
        .eq("section_key", sectionKey)
        .maybeSingle();

      if (cancelled) return;
      if (error || !row?.data) {
        setData(getDefaultSectionJson(sectionKey));
      } else {
        setData(row.data);
      }
      setLoading(false);
    })();

    return () => {
      cancelled = true;
    };
  }, [sectionKey]);

  return { data, loading };
}
